(function() { window.GUID_95e1c6b5_d183_4c58_8e41_8618ba6cd6b0 = { getGuid: function() { return "95e1c6b5-d183-4c58-8e41-8618ba6cd6b0"; } }; })();
BindButtons();
function BindButtons() {
    var btnResetPassword = $('#BtnResetPassword');
    var btnResetUserData = $('#BtnResetUserData');
    var btnLinkCompuSportToFacebook = $('#BtnLinkCompuSportToFacebook');
    var btnUnlinkFacebook = $('#BtnUnlinkFacebook');
    var btnLinkFacebook = $('#BtnLinkFacebookToCompuSport');
    var btnApplyChangeToMyAccount = $('#BtnApplyChangeToMyAccount');
    var btnUnlinkOperator = $('#BtnUnlinkOperator');
    let $masterAdminDisabledCheckbox = $('#MasterAdminDisabled');
    if ($masterAdminDisabledCheckbox.length) {
        $masterAdminDisabledCheckbox.on('loaded', function () {
            let $this = $(this);
            $this.on('change', function () {
                CompuSport.Ajax.Post(CSParameters.BaseUrl + 'Account/ToggleMyMasterAdminRole/', null, function (response) {
                    window.location.reload();
                });
            });
        });
    }
    btnResetUserData.off('click');
    btnResetPassword.on('click', function (e) {
        e.preventDefault();
        // var postButton = $(this);
        //CS.Account.ShowValidateUserPopup(true, function (password: string) {
        CompuSport.Ajax.Post(CSParameters.BaseUrl + 'Account/AjaxResetPassword/', null, function (response) {
            var popup = new CompuSport.Controls.Popup();
            popup.Show(response, { PopupId: 'ResetPasswordCalled', Buttons: 'Ok' });
        });
        //});      
    });
    btnResetUserData.on('click', function (e) {
        e.preventDefault();
        CompuSport.Ajax.Post(CSParameters.BaseUrl + "Account/ResetCSUserData/" + CSParameters.SportEventId, null, function (response) {
            btnResetUserData.hide();
        });
    });
    btnUnlinkOperator.off('click');
    btnUnlinkOperator.on('click', function (e) {
        e.preventDefault();
        CS.Account.ShowValidateUserPopup(true, function (popup, password) {
            var data = { operatorId: $('#OperatorId').val(), password: password, associationId: $('#AssociationId').val() };
            CompuSport.Ajax.Post(CSParameters.BaseUrl + "Account/UnlinkOperator/" + CSParameters.SportEventId, data, function (response) {
                window.location.reload();
            });
        });
    });
    btnLinkFacebook.off('click');
    btnLinkFacebook.on('click', function (e) {
        CS.Account.ShowValidateUserPopup(true, function (popup, password) {
            var data = { password: password };
            popup.Popup.addClass('ClickToContinue');
            var clickToContinue = $('#ClickToContinue', popup.Content);
            clickToContinue.on('click', function (e) {
                e.preventDefault();
                FB.login(function (response) {
                    checkLoginStatusCallback(response, 'LinkFacebookToCompuSport', password);
                }, { scope: 'email' });
            });
        }, function (popup) {
            var okButton = $('.PostButton', popup.ButtonsContainer);
            okButton.addClass('DoNotCloseOnClick');
        });
    });
    btnLinkCompuSportToFacebook.off('click');
    btnLinkCompuSportToFacebook.on('click', function (e) {
        e.preventDefault();
        CS.Account.ShowValidateUserPopup(false, function (popup, password, email) {
            var data = { email: '', password: '' };
            data.email = email;
            data.password = password;
            CompuSport.Ajax.Post(CSParameters.BaseUrl + "Account/LinkCompuSportToFacebook/" + CSParameters.SportEventId, data, function (response) {
                window.location.reload();
            });
        });
    });
    btnUnlinkFacebook.off('click');
    btnUnlinkFacebook.on('click', function (e) {
        e.preventDefault();
        CS.Account.ShowValidateUserPopup(true, function (popup, password) {
            var data = { password: password };
            CompuSport.Ajax.Post(CSParameters.BaseUrl + "Account/UnlinkFacebook/" + CSParameters.SportEventId, data, function (response) {
                window.location.reload();
            });
        });
    });
    btnApplyChangeToMyAccount.off('click');
    btnApplyChangeToMyAccount.on('click', function (e) {
        e.preventDefault();
        var postButton = $(this);
        var isFacebookOnlyAccount = $('#IsFacebookOnlyAccount').val();
        if (isFacebookOnlyAccount == "True") {
            FB.login(function (response) {
                if (response.status === 'connected') {
                    ApplyChangeToMyAccount(postButton);
                }
            }, { scope: 'email', auth_type: 'reauthenticate' });
        }
        else {
            CS.Account.ShowValidateUserPopup(true, function (popup, password) {
                ApplyChangeToMyAccount(postButton);
            });
        }
    });
    function ApplyChangeToMyAccount(postButton) {
        var form = postButton.closest('form');
        var data = {
            Email: $('#Email', form).val(),
            FirstName: $('#FirstName', form).val(),
            LastName: $('#LastName', form).val(),
        };
        CompuSport.Ajax.Post(CSParameters.BaseUrl + "Account/ApplyChangeToMyAccount/" + CSParameters.SportEventId, data, function (response) {
            var popup = new CompuSport.Controls.Popup();
            popup.Show(response, { PopupId: 'ApplyChangeToMyAccountConfirmed', Buttons: 'Ok' });
            popup.OnClosed = function () {
                window.location.reload();
            };
        });
    }
    btnApplyChangeToMyAccount.show();
    btnResetPassword.show();
    btnResetUserData.show();
}

//# sourceMappingURL=EditMyUserAccount.js.map
